import React from "react";
import Drawer from "rc-drawer";
import { Tooltip } from "../../../core";

export const DeviceLists = props => {
  const {
    isDrawerOpen,
    handleDisplayPlayingDevices,
    selectedCampaignData
  } = props;
  return (
    <Drawer
      className="overlay-drawer search-drawer"
      open={isDrawerOpen}
      handler={false}
      level={null}
      placement="right"
    >
      <span className="campaignDetail__information searchlist-container mt-0 mb-2">
        Currently Playing Devices
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => handleDisplayPlayingDevices(undefined, false)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </span>

      <p className="pl-4">
        Campaign{" "}
        <strong>
          {" "}
          {selectedCampaignData && selectedCampaignData.attributes.name}
        </strong>{" "}
        is playing on the following{" "}
        {selectedCampaignData && selectedCampaignData.devices.length > 1
          ? "devices"
          : "device"}{" "}
        .
      </p>

      {selectedCampaignData &&
        selectedCampaignData.devices.map(item => (
          <div className="search-results pt-2">
            <ul>
              <li className="media-body">
                <div className="d-flex">
                  <h5 className="mr-auto">
                    {item.attributes.hostname || "N/A"}
                  </h5>
                  <span
                    className={`mt-1 content-text ${
                      item.attributes.status === "offline"
                        ? "content__status__offline"
                        : "content__status__online"
                    }`}
                  />
                </div>
                <div className=" mt-2 searchResultWrapper">
                  <div className="row">
                    <div className="col-md-4">Mac Address</div>
                    <div className="col-md-3 ">Name</div>
                    <div className="col-md-2 ">Domain</div>
                    <div className="col-md-3">Group</div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <b>{item.attributes.mac_address || "N/A"}</b>
                    </div>
                    <div className="col-md-3 ">
                      {" "}
                      {item.attributes.name &&
                      item.attributes.name.length > 10 ? (
                        <Tooltip
                          item={
                            <b>{`${item.attributes.name.slice(0, 10)} ...`}</b>
                          }
                          id={`viewname-${item.id}-name`}
                          tooltipContent={item.attributes.name}
                        />
                      ) : (
                        <b> {item.attributes.name || "N/A"} </b>
                      )}
                    </div>
                    <div className="col-md-2 ">
                      {" "}
                      {item.attributes.domain_name &&
                      item.attributes.domain_name.length > 7 ? (
                        <Tooltip
                          item={
                            <b>{`${item.attributes.domain_name.slice(
                              0,
                              7
                            )} ...`}</b>
                          }
                          id={`${item.id}-domain`}
                          tooltipContent={item.attributes.domain_name}
                        />
                      ) : (
                        <b> {item.attributes.domain_name || "N/A"} </b>
                      )}
                    </div>
                    <div className="col-md-3">
                      {item.attributes.group_name &&
                      item.attributes.group_name.length > 10 ? (
                        <Tooltip
                          item={
                            <b>{`${item.attributes.group_name.slice(
                              0,
                              10
                            )} ...`}</b>
                          }
                          id={`${item.id}-group`}
                          tooltipContent={item.attributes.group_name}
                        />
                      ) : (
                        <b> {item.attributes.group_name || "N/A"} </b>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        ))}
    </Drawer>
  );
};
